"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.delete_social_media = void 0;
var api_1 = require("../../api");
var delete_social_media = function (req) {
    return (0, api_1.apiDelete)({
        endpoint: "v3/client/delete_social_media",
        data: req,
    });
};
exports.delete_social_media = delete_social_media;
